import api from './index';

// 分页查询设备日志数据
export function fetchDeviceLogData(params) {
    // 从 localStorage 获取 token
    const token = localStorage.getItem('token');

    // 使用 Authorization Bearer token 的方式传递 token
    return api.post('/web/devicelog/page', params, {
        headers: {
            Authorization: `Bearer ${token}` // 将 token 放入 Authorization 请求头
        }
    });
}

// 导出日志数据
export function exportLogData(params) {
    return api.post('/web/devicelog/export', params, {
        responseType: 'blob',
        headers: {
            'Content-Type': 'application/json',
            // 明确要求返回Excel格式
            'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        },
        // 关键：禁用axios的默认转换
        transformResponse: [(data) => {
            // 如果是IE，可能需要特殊处理
            if (typeof window.navigator.msSaveBlob !== 'undefined') {
                return data;
            }
            return data instanceof Blob ? data : new Blob([data]);
        }]
    });
}